export const OLDRAW_CLICKTOLERANCE = 150;
